<form (ngSubmit)="onSubmit()" [formGroup]="form" class="pos-relative form">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <ng-container *ngIf="model">
    <div class="form-group my-15">
      <label class="form-label required">Name</label>
      <input [(ngModel)]="model.name" formControlName="name" type="text" class="form-control" required>
      <input-errors [control]="form.controls.name" [service]="validationService"></input-errors>
    </div>
    <div class="form-group my-15">
      <label class="form-label">Description</label>
      <textarea [(ngModel)]="model.description" formControlName="description" class="form-control"></textarea>
      <input-errors [control]="form.controls.description" [service]="validationService"></input-errors>
    </div>
    <div class="form-group my-15">
      <div class="input-check">
        <label class="form-label" (click)="enabled.click()">Enabled</label>
        <div class="form-check form-switch">
          <input #enabled type="checkbox" class="form-check-input" [(ngModel)]="model.enabled" formControlName="enabled" />
        </div>
      </div>
    </div>
    <div class="form-group my-15">
      <div class="input-check">
        <label class="form-label" (click)="withdrawalAvailable.click()">Autopay</label>
        <div class="form-check form-switch">
          <input #withdrawalAvailable type="checkbox" class="form-check-input" [(ngModel)]="model.withdrawalAvailable" formControlName="withdrawalAvailable" />
        </div>
      </div>
    </div>
    <ng-container *ngIf="showButtons">
      <div *ngIf="showButtons" class="text-right buttons">
        <a href="javascript:history.back();" class="btn btn-danger m-b m-r">Cancel</a>
        <button id="btn-appscripts-payment-method-apply" type="submit" [disabled]="!form.valid" class="btn btn-primary m-b">Apply</button>
      </div>
    </ng-container>
  </ng-container>
</form>
<style>
  .input-check {
    display: flex;
  }

  .form-check {
    margin-left: 0.5rem;
  }
</style>
